/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { VApplication } from '@/application';
import { toHeaderCase } from 'js-convert-case';
import config from '../config/preview.config.json';

export interface IFormatOrgListMethods extends IPluginMethodMap {
  getFormatOrgListSync(args: any): any;
}

export class FormatOrgListService implements IAgentPlugin {
  readonly methods: IFormatOrgListMethods;

  constructor() {
    this.methods = {
      getFormatOrgListSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    let _templateData = this.formatOrgList(args);
    return {
      ...config,
      userGroups: {
        appCardList: _templateData,
        isEmpty: args?.length <= 0,
        activePage: args?.currentPage,
        pageSize: args?.pageSize,
        totalCount: args?.totalCount,
        totalPages: args?.totalPages,
      },
    };
  }

  private formatOrgList(data: any) {
    console.log('formatHolderGroup =>', data);
    let _appCard =
      data &&
      Array.isArray(data) &&
      data?.length > 0 &&
      data?.map((item: any) => {
        return {
          appCardId: item?.id,
          appCardImage: item?.logo,
          appCardTitle: item?.name,
          appCardDescription: item?.description,
        };
      });

    return _appCard;
  }
}
